import { ENTITY_REPORT_TARGET_TYPE } from 'utils';

export const bankAccountQuery = {
  page: 1,
  take: 10,
  name: '',
  order: { name: 'isDefault', value: 0 },
};

export const bankAccountSelectQuery = {
  search: '',
  order: { name: 'isDefault', value: 0 },
};

export const entityNotifyQuery = {
  page: 1,
  take: 10,
  reserved: true,
  search: '',
};

export const entityReportQuery = {
  page: 1,
  take: 10,
  reserved: true,
  targetType: ENTITY_REPORT_TARGET_TYPE.ORDER,
  order: { name: 'createdAt', value: 0 },
};

export const entityBalanceReportQuery = {
  page: 1,
  take: 10,
  reserved: true,
  targetType: ENTITY_REPORT_TARGET_TYPE.BALANCED_ORDER,
  order: { name: 'createdAt', value: 0 },
};

export const entityQuantityReportQuery = {
  page: 1,
  take: 10,
  reserved: true,
  targetType: ENTITY_REPORT_TARGET_TYPE.PROPOSAL_ITEM,
  order: { name: 'createdAt', value: 0 },
};

export const entityLocationExistQuery = {
  search: '',
  select: ['id', 'districtCode', 'provinceCode', 'status'],
  order: { name: 'createdAt', value: -1 },
};

export const entityDistanceShippingFeeQuery = {
  page: 1,
  take: 10,
  reserved: true,
  search: '',
  order: { name: 'distance', value: 0 },
  // order: { name: 'createdAt', value: 0 },
};

export const entityCustomShippingFeeQuery = {
  page: 1,
  take: 10,
  reserved: true,
  search: '',
  order: { name: 'createdAt', value: 0 },
};

export const entityLocationShippingFeeQuery = {
  page: 1,
  take: 10,
  reserved: true,
  search: '',
  order: { name: 'createdAt', value: 0 },
};

export const entityPackingFeeQuery = {
  page: 1,
  take: 10,
  order: { name: 'weight', value: -1 },
};

export const entityLocationFreeShipQuery = {
  order: { name: 'createdAt', value: 0 },
};
